import React, { Component } from 'react';
import i18n from 'kodyl-js/i18n/react';
import FacebookLoginButton from './button';

@i18n
class FacebookLogin extends Component {
  render() {
    return (
      <div style={{ padding: '15px', background: 'whiteSmoke' }}>
        <p>
          {this.i18n(
            'Use your social media account to create a user in just a few clicks - quick and easy.'
          )}
        </p>
        <FacebookLoginButton />
      </div>
    );
  }
}

export default FacebookLogin;
